const IMG_BASE = "https://resource.fzhitong.cn"
const Constant = {
    companyGuid: '', //公司guid 打包修改
    DEFAULT_COMPANY_GUID: '', //公司guid 打包修改
    DEFAULT_CITY_REGION: "010100",
    DEFAULT_CITY_CODE: "156511100",
    DEFAULT_CITY_NAME: '乐山市',
    CHOOSELOCATION: "CHOOSELOCATION",
    CUSTOMER: "CUSTOMER",
    ACCESSTOKEN: "ACCESSTOKEN",
    DEFAULT_CITY_LAT: 29.566132,
    DEFAULT_CITY_LNG: 103.768902,
    DEFAULT_HOUSE: 'https://resource.fzhitong.cn/house_cover_img_new_v1.png',
    DEFAULT_BUILD_VR: '@/assets/images/detail_icon/default-build-Vr.png',
    DEFAULT_AVATAR: 'https://resource.fzhitong.cn/default-customerAvatar.png',

    // BAIDU_AK: "HgCJH7Gv7hjpXPzfyE9sQqRNPWRDaiam",
    BAIDU_AK: "2MnXaU6DVKk5kZr2qRHqQ2MPUPSQoEdY",

    SECOND_HISTORY: "SECOND_HISTORY", // 搜索历史
    SEARCH_RECORDS: "SEARCH_RECORDS", //我的搜索
    RENT_HISTORY: 'RENT_HISTORY',
    NEW_ESTATE_HISTORY: "NEW_ESTATE_HISTORY",
    CITY_COMPANY: 'CITY_COMPANY',
    IS_GET_LOCATION: 'IS_GET_LOCATION',
    IS_REFRESH_PAGE: 'IS_REFRESH_PAGE',
    IS_SORCE_ERP: "IS_SORCE_ERP",

    AGREEMENT_USE: "https://api.fzhitong.cn/api/content/customer/useAgreement",//用户协议
    AGREEMENT_PRIVACY: "https://api.fzhitong.cn/api/content/agent/agreement/privacy",//隐私政策

    DEV_MODE: "development",//开发环境配置
    PRO_MODE: "production",//线上环境配置
    MODE: "production",
    ARTICLE_URL: '/article/web/article/detail/',
    IMG_HZ: '?imageView2/1/w/520/h/360/q/90',

    IMG_BASE,
    IMG_OTHER_URL: IMG_BASE + "/zhaofang/other",
    // IMG_ICON_URL: IMG_BASE + "/zhaofang/icon",

    IMG_ICON_URL: IMG_BASE,

    // 图片参数
    UPLOAD_ACCESS_KEY: '5BzbFPlztI2i5UeQ2irI63A15XwrvnQSeNHlEx-O',
    UPLOAD_SECRET_KEY: 'Gf3J21KozvG7yPPPoyVTSP0JQxUFlCjneMCCp3Bq',
    UPLOAD_BUCKET_NAME: 'erpleshan',
    UPLOAD_URL: "https://up-z1.qiniup.com",
    UPLOAD_URL_TO_REP: "https://up-z2.qiniup.com",
    UPLOAD_URL_PUT: 'https://up-z1.qiniup.com/putb64/-1/key/',
    IMAGE_PREFIX: 'https://resource.fzhitong.cn/',
};

module.exports = Constant